(function() {
    'use strict';

    angular
        .module('szallodak-unique-offer', ['ui.bootstrap']);
})();
